/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BulkUploadDataError,
    BulkUploadDataErrorFromJSON,
    BulkUploadDataErrorFromJSONTyped,
    BulkUploadDataErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface BulkUploadDataResponse
 */
export interface BulkUploadDataResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BulkUploadDataResponse
     */
    hasErrors?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BulkUploadDataResponse
     */
    waterMark?: number;
    /**
     * 
     * @type {Array<BulkUploadDataError>}
     * @memberof BulkUploadDataResponse
     */
    errors?: Array<BulkUploadDataError> | null;
}

export function BulkUploadDataResponseFromJSON(json: any): BulkUploadDataResponse {
    return BulkUploadDataResponseFromJSONTyped(json, false);
}

export function BulkUploadDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUploadDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasErrors': !exists(json, 'hasErrors') ? undefined : json['hasErrors'],
        'waterMark': !exists(json, 'waterMark') ? undefined : json['waterMark'],
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(BulkUploadDataErrorFromJSON)),
    };
}

export function BulkUploadDataResponseToJSON(value?: BulkUploadDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasErrors': value.hasErrors,
        'waterMark': value.waterMark,
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(BulkUploadDataErrorToJSON)),
    };
}


